import { useEffect, useMemo, useState } from "react";

import { getData, Postdata } from "../../../API/GlobalApi";
import { useNavigate } from "react-router-dom";
import Notifier from "../../../Utils/notify";
import { reactSelectStyles } from "../../../Utils/selectBoxStyle";
import Select from 'react-select'
import AddFeeHeadModal from "../../../Component/Modals/AddFeeHead";
import ConfirmationModal from "../../../Component/Modals/ConfirmationModal";
import OtpModal from "../../../Component/Modals/DiscountOtpInput";
import { ImposeFeePlanPreview } from "../../../Component/Modals/ImposeFeePlanPreview";

const AddHolidays = () => {

    // State
    const [courseData, setCourseData] = useState([]);
    const [courseOptions, setCourseOptions] = useState([]);
    const [semesterOptions, setSemesterOptions] = useState([]);
    const [sectionOptions, setSectionOptions] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedSemester, setSelectedSemester] = useState(null);
    const [selectedSections, setSelectedSections] = useState([]);
    const [allCourseStudents, setAllCourseStudents] = useState([]);
    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState([]); // not null
    const [selectedStudentFeePlan, setSelectedStudentFeePlan] = useState([]); // not null
    const [searchTerm, setSearchTerm] = useState("");
    const [showStudents, setShowStudents] = useState(false);
    const [showEmployee, setShowEmployee] = useState(false);
    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);

    // const holidayTypeOptions = [
    //     { label: "Public", value: "public" },
    //     { label: "Optional", value: "optional" },
    //     { label: "Restricted", value: "restricted" },
    //     { label: "Gazetted", value: "gazetted" }
    // ];


    const [holidayType, setHolidayType] = useState(null);
    const [holidayName, setHolidayName] = useState("");
    const [holidayFrom, setHolidayFrom] = useState("");
    const [holidayTo, setHolidayTo] = useState("");
    const [recurrenceType, setRecurrenceType] = useState(null);
    const [repeatInterval, setRepeatInterval] = useState(1);
    const [daysOfWeek, setDaysOfWeek] = useState([]);
    const [repeatUntil, setRepeatUntil] = useState("");
    const [monthlyOption, setMonthlyOption] = useState(null);
    const [monthWeek, setMonthWeek] = useState(null);
    const [monthWeekDay, setMonthWeekDay] = useState(null);
    useEffect(() => {
        if (recurrenceType?.value === "weekly") {
            setDaysOfWeek([{ label: "Sunday", value: "sunday" }]);
        }
    }, [recurrenceType]);

    const getSessions = async () => {
        const response = await getData("academics/academic-years/");
    

        const options = response?.map((session) => ({
            value: session.id,
            label: session.name,
            is_current: session.is_current,
        }));

        setSessions(options);
        // Find the default session where is_current is true
        const currentSession = options.find((opt) => opt.is_current);
        if (currentSession) {
            setSelectedSession(currentSession);
        }
    };

    const [employeeData, setEmployeeData] = useState([])
    const getEmployee = async () => {
        const response = await getData("staff/get-employees");
        setEmployeeData(response?.results || [])
    }

    useEffect(() => {
        getEmployee()
        getSessions();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (!selectedSession) return;
            // Reset selections
            setSelectedCourse(null);
            setSelectedSemester(null);
            setSelectedSections([]);
            setSemesterOptions([]);
            setSectionOptions([]);
            setStudents([]);
            setAllCourseStudents([]);
            setSelectedStudent([]);
            setShowStudents(false);
            // build query parameter
            const query = `?academic_year_id=${selectedSession.value}`;
            const res = await getData(`finance/specializations/${query}`);
       
            if (Array.isArray(res)) {
                setCourseData(res);
                setCourseOptions(
                    res.map((c) => ({ value: c.id, label: c.full_name }))
                );
            }

        };

        fetchData();
    }, [selectedSession]); // re-run when session changes


    // When course changes → set semesters, collect all students

    useEffect(() => {
        if (!selectedCourse) {
            setSemesterOptions([]);
            setSectionOptions([]);
            setStudents([]);
            setAllCourseStudents([]);
            setSelectedStudent([]);
            setShowStudents(false);
            setSelectedSemester(null);
            setSelectedSections([]);
            return;
        }

        const course = courseData.find(c => c.id === selectedCourse.value);

        if (course?.academic_groups) {
            const semesters = course.academic_groups.map(s => ({ value: s.id, label: s.name }));
            setSemesterOptions(semesters);

            let courseStudents = [];
            course.academic_groups.forEach(semester => {
                semester.lags?.forEach(section => {
                    section.students?.forEach(stu => {
                        courseStudents.push({
                            id: stu.user_id,
                            name: stu.full_name,
                            rollNumber: stu.permanent_registration_number,
                            semester: semester.id,
                            semesterName: semester.name,
                            section: section.id,
                            sectionName: section.name,
                            courseId: course.id,
                            feeSchedules: stu.fee_schedules || []
                        });
                    });
                });
            });

            setAllCourseStudents(courseStudents);
            setStudents(courseStudents);
            setSelectedStudent(courseStudents.map(s => s.id)); // all selected by default
            setShowStudents(false);
            setSelectedSemester(null);
            setSelectedSections([]);
            setSectionOptions([]);
        } else {
            setAllCourseStudents([]);
            setStudents([]);
            setSelectedStudent([]);
            setSemesterOptions([]);
            setSectionOptions([]);
            setShowStudents(false);
            setSelectedSemester(null);
            setSelectedSections([]);
        }
    }, [selectedCourse]);

    // SEMESTER selection
    useEffect(() => {
        if (!selectedSemester) {
            setStudents(allCourseStudents);
            setSectionOptions([]);
            setSelectedSections([]);
            return;
        }

        const semesterId = selectedSemester.value;

        const filteredBySemester = allCourseStudents.filter(stu => stu.semester === semesterId);
        setStudents(filteredBySemester);
        setSelectedStudent(filteredBySemester.map(s => s.id)); // keep all selected

        // Enable section dropdown
        const course = courseData.find(c => c.id === selectedCourse?.value);
        const semesterData = course?.academic_groups.find(s => s.id === semesterId);

        const sections = semesterData?.lags?.map(sec => ({ value: sec.id, label: sec.name })) || [];
        setSectionOptions(sections);
        setSelectedSections([]);
    }, [selectedSemester, allCourseStudents, selectedCourse, courseData]);

    // SECTION selection
    useEffect(() => {
        if (!selectedSections.length) {
            if (selectedSemester) {
                const filteredBySemester = allCourseStudents.filter(stu => stu.semester === selectedSemester.value);
                setStudents(filteredBySemester);
                setSelectedStudent(filteredBySemester.map(s => s.id));
            } else {
                setStudents(allCourseStudents);
                setSelectedStudent(allCourseStudents.map(s => s.id));
            }
            return;
        }

        const sectionIds = selectedSections.map(s => s.value);
        const filteredBySection = allCourseStudents.filter(stu => sectionIds.includes(stu.section));
        setStudents(filteredBySection);
        setSelectedStudent(filteredBySection.map(s => s.id));
    }, [selectedSections, allCourseStudents, selectedSemester]);



    const filteredStudents = useMemo(() => {
        let result = [...allCourseStudents];

        if (selectedCourse) {
            result = result.filter(stu => stu.courseId === Number(selectedCourse.value));
        }
        if (selectedSemester) {
            result = result.filter(stu => stu.semester === Number(selectedSemester.value));
        }
        if (selectedSections?.length) {
            const sectionIds = selectedSections.map(s => s.value);
            result = result.filter(stu => sectionIds.includes(stu.section));
        }

        // // 🔹 Apply Fee Head Filter
        // if (selectedFeeHeads.length > 0) {
        //     result = result.filter(stu =>
        //         (stu.feeSchedules || []).some(fs =>
        //             selectedFeeHeads.includes(Number(fs.fee_type_head_pk))
        //         )
        //     );
        // }

        // 🔹 Apply search filter
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            result = result.filter(stu =>
                stu.name?.toLowerCase().includes(term) ||
                stu.rollNumber?.toLowerCase().includes(term) ||
                stu.mobile_number?.toString().includes(term) ||
                stu.email?.toLowerCase().includes(term)
            );
        }

        return result;
    }, [
        allCourseStudents,
        selectedCourse,
        selectedSemester,
        selectedSections,

        searchTerm
    ]);

    const [feeRows, setFeeRows] = useState([{ semester: null, feeHead: null, amount: '' }]);
    const [feeHeadOptions, setFeeHeadOptions] = useState([]);


    const navigate = useNavigate();

    useEffect(() => {
        const getFeeTypes = async () => {
            try {
                const res = await getData('students/get-payment-types/');

                let options = (res?.fee_heads || []).map(t => ({
                    label: t.name,
                    value: t.id
                }));

                // Append special option
                options.push({ label: "+ Add Fee Head", value: "__add__" });

                setFeeHeadOptions(options);
            } catch (err) {
                setFeeHeadOptions([{ label: "+ Add Fee Head", value: "__add__" }]);
            }
        };
        getFeeTypes();
    }, []);


    const [showAddModal, setShowAddModal] = useState(false);
    const [activeRowIndex, setActiveRowIndex] = useState(null);

    const handleFeeHeadChange = (val, idx) => {
        if (val?.value === "__add__") {
            setActiveRowIndex(idx); // store which row to update later
            setShowAddModal(true);
        } else {
            updateFeeRow(idx, "feeHead", val);
        }
    };



    const [newFeeHead, setNewFeeHead] = useState("");
    const handleAddFeeHead = async () => {
        try {
            const res = await Postdata("core/fee-type-heads/", { name: newFeeHead });
            if (res?.id) {
                Notifier.success("Fee Head created successfully");

                const newOption = { label: res.name, value: res.id };

                // ✅ Update options (keep "+ Add Fee Head" at end)
                setFeeHeadOptions(prev => [
                    ...prev.filter(opt => opt.value !== "__add__"),
                    newOption,
                    { label: "+ Add Fee Head", value: "__add__" }
                ]);

                // ✅ Update the correct row with the new Fee Head (so it becomes selected)
                if (activeRowIndex !== null) {
                    updateFeeRow(activeRowIndex, "fee_type_head_id", newOption.value);
                    updateFeeRow(activeRowIndex, "fee_type_head", newOption.label);
                }

                setShowAddModal(false);
                setNewFeeHead("");
            } else {
                let errorMsg = "Failed to create Fee Head";
                if (res && typeof res === "object") {
                    const fieldErrors = Object.entries(res)
                        .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
                        .join("\n");
                    if (fieldErrors) errorMsg = fieldErrors;
                }
                Notifier.error(errorMsg);
            }
        } catch (err) {
            Notifier.error("Something went wrong. Please try again.");
        }
    };


    const toggleAll = (e) => {
        if (e.target.checked) setSelectedStudent(students.map(s => s.id));
        else setSelectedStudent([]);
    };

    const toggleOne = (id) => {
        setSelectedStudent(prev => prev.includes(id) ? prev.filter(sid => sid !== id) : [...prev, id]);
    };

    const addFeeRow = () => setFeeRows(prev => [...prev, { semester: null, feeHead: null, amount: '' }]);

    const updateFeeRow = (index, key, value) => {
        setFeeRows(prev => {
            const copy = [...prev];
            copy[index] = { ...copy[index], [key]: value };
            return copy;
        });
    };

    const removeFeeRow = (index) => setFeeRows(prev => prev.filter((_, i) => i !== index));

    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [previewData, setPreviewData] = useState(null)

    const buildFeePlanPayload = () => {
        // let studentIdsToSend = [];
        // let planMode = "";

        // if (!showStudents) {
        //     // list not opened → course
        //     planMode = "course";
        //     studentIdsToSend = allCourseStudents.map(s => s.id);
        // } else {
        //     if (selectedStudent.length === students.length) {
        //         // all selected → still course
        //         planMode = "course";
        //         studentIdsToSend = students.map(s => s.id);
        //     } else {
        //         // some selected → individual
        //         planMode = "individual";
        //         studentIdsToSend = selectedStudent;
        //     }
        // }

        // 1️⃣ take currently filtered students
        const visibleStudents = filteredStudents;

        // 2️⃣ take only selected students that are part of visible
        const studentIdsToSend = selectedStudent.filter(id =>
            visibleStudents.some(stu => stu.id === id)
        );

        // 3️⃣ decide plan mode
        const isAllSelected =
            visibleStudents.length > 0 &&
            studentIdsToSend.length === visibleStudents.length;

        const planMode = isAllSelected ? "course" : "individual";


        let payload;
        if (planMode === "course") {
            payload = {
                specialization_id: selectedCourse?.value || null,
                semester_id: selectedSemester?.value || null,
                payments: feeRows.map(r => ({
                    fee_head_id: r.fee_type_head_id || null,
                    amount: Number(r.amount) || 0,
                })),
                employee_ids: selectedEmployeeIds.join(","),
            };
        } else {
            payload = {
                plan_mode: "individual",
                student_ids: studentIdsToSend.join(","),
                payments: feeRows.map(r => ({
                    academic_group_id: selectedSemester?.value || null,
                    amount: Number(r.amount) || 0,
                    fee_head_id: r.fee_type_head_id || null,
                })),
                employee_ids: selectedEmployeeIds.join(","),
            };
        }

        return { payload, planMode, studentIdsToSend };
    };



    const handleBeforeSubmit = () => {
        const { payload, planMode, studentIdsToSend } = buildFeePlanPayload();

        setPreviewData({
            planMode,
            payload,
            studentIdsToSend,
            selectedCourse,
            selectedSemester,
            students,
            selectedStudent,
            feeRows,

        });

        setPreviewOpen(true);
    };

    const handleConfirmFeePlan = async () => {
        setIsSubmitting(true); // show loader

        try {
            await handleSubmit();
        } finally {
            setIsSubmitting(false);
            setConfirmationModalOpen(false);
        }
    };

    const [otpModal, setOtpModal] = useState(false)
    const [helpdeskperson, setHelpDeskPerson] = useState([]);
    const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]); // now an array


    const gethelpdeskPerson = async () => {
        const url = "finance/course-fee-plans/authorized-employees/?type=impose";
        const response = await getData(url);
        setHelpDeskPerson(response?.authorized_employees)

    }
    const getClasses = async () => {
        const response = await getData('finance/specializations')
        setCourseData(response || []);
    }
    useEffect(() => {
        getClasses()
        gethelpdeskPerson()
    }, [])






    const [specializationSubmitResponse, setSpecializationSubmitResponse] = useState()

    const handleOtpConfirm = async (otpCode) => {
        try {
            let url = "";
            let payload = {};

            if (specializationSubmitResponse?.plan_mode === "course") {

                url = "finance/course-fee-plans/verify/";
                payload = {
                    specialization_id: selectedCourse?.value || null,
                    unique_id: specializationSubmitResponse?.unique_id,
                    otp: otpCode, // ✅ add OTP here
                };
            } else {

                url = "finance/fee-schedules/verify-and-create/";
                payload = {
                    unique_id: specializationSubmitResponse?.unique_id,
                    otp: otpCode, // ✅ add OTP here
                };
            }

            const response = await Postdata(url, payload);

            if (response?.error) {

                Notifier.error(response?.error || "OTP verification failed");
            } else {
                Notifier.success("Fee Imposed Successfully!");
                setOtpModal(false);
                // navigate(-1); // back to list page
                // after OTP success
                navigate(-1, { state: { refreshKey: Date.now() } });

                // Optionally reset form state if needed
                // setCachedSelectedFeePlan(null);
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };

    const handleOtpCancel = () => {

        setSelectedCourse(null)
        setOtpModal(false);
        setSelectedEmployeeIds([])
        navigate(-1)

    }


    const handleOtpResend = async () => {
        try {
            let url = "";
            let payload = {};

            if (specializationSubmitResponse?.plan_mode === "course") {

                url = "finance/course-fee-plans/resend-verification-otp/";
                payload = {
                    unique_id: specializationSubmitResponse?.unique_id,
                    specialization_id: selectedCourse?.value || null,
                    employee_ids: selectedEmployeeIds.join(","),
                };
            } else {

                url = "finance/fee-schedules/resend-otp/";
                payload = {
                    unique_id: specializationSubmitResponse?.unique_id,
                    employee_ids: selectedEmployeeIds.join(","),
                };
            }

            const response = await Postdata(url, payload);

            if (!response?.error) {
                if (specializationSubmitResponse?.plan_mode === "course") {

                    setSpecializationSubmitResponse((prev) => ({
                        ...prev,
                        otp: response?.otps || null,
                        unique_id: response?.unique_id || prev?.unique_id,
                        plan_mode: prev?.plan_mode,
                    }));
                } else {
                    // individual API gives OTP array
                    setSpecializationSubmitResponse({ otp: response.otps, unique_id: response.pending_plan_id })
                }

                Notifier.success(response?.message || "OTP resent successfully!");
            } else {
                Notifier.error(response?.error || "Failed to resent OTP.");
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };


    // Called when user cancels inside the modal
    const handleCancelFeePlan = () => {
        if (!isSubmitting) {  // prevent cancel while loading
            setConfirmationModalOpen(false);
        }

    };
    const isFormValid =
        holidayType &&                          // holiday type must be selected
        holidayName?.trim() !== "" &&           // holiday name must not be empty
        holidayFrom &&                           // from date must be selected
        holidayTo &&                             // to date must be selected
        new Date(holidayFrom) <= new Date(holidayTo) && // from date ≤ to date
        selectedStudent?.length > 0 &&          // at least one student selected
        selectedEmployeeIds?.length > 0;        // at least one employee selected




    const handleSubmit = async () => {
        try {
            const { payload, planMode } = buildFeePlanPayload();

            const endpoint =
                planMode === "course"
                    ? "finance/course-fee-plans/new/create/"
                    : "finance/fee-schedules/";

            const response = await Postdata(endpoint, payload);

            if (response.error && response.error.trim() !== "") {
                const cleanedError = response.error
                    .replace(/^\[|\]$/g, "")
                    .replace(/['"]+/g, "")
                    .trim();
                Notifier.error(cleanedError);
            } else {
                if (response?.otps) {
                    setSpecializationSubmitResponse({
                        otp: response.otps,
                        unique_id: response?.unique_id || response?.pending_plan_id,
                        plan_mode: planMode,
                    });
                    setOtpModal(true);
                    setSelectedFeePlan(response?.purchase_order);
                }
                Notifier.success("OTP sent successfully!");
            }
        } catch (error) {
            console.error("Error submitting fee plan:", error);
            Notifier.error("Failed to submit fee plan. Please try again.");
        }
    };





    const [showFeePlanModal, setShowFeePlanModal] = useState(false);
    const [selectedFeePlan, setSelectedFeePlan] = useState(null);
    const [selectedStudentName, setSelectedStudentName] = useState('');



    // Modal state
    const [showHolidayTypeAddModal, setShowHolidayTypeAddModal] = useState(false);
    const [newHolidayType, setNewHolidayType] = useState("");



    const [holidayTypeOptions, setHolidayTypeOptions] = useState([
        { label: "Public", value: "public" },
        { label: "Optional", value: "optional" },
        { label: "Restricted", value: "restricted" },
        { label: "Gazetted", value: "gazetted" }
    ]);
    const handleAddHolidayType = (newType) => {
        const newOption = {
            label: newType,
            value: newType.toLowerCase().replace(/\s+/g, "-"),
        };
        setHolidayTypeOptions((prev) => [...prev, newOption]);
        setHolidayType(newOption);
        setShowHolidayTypeAddModal(false);
    };
    const holidayTypeOptionsWithAdd = [
        ...holidayTypeOptions,
        { label: "+ Add Holiday Type", value: "__add__" }
    ];


    return (
        <>

            <div className="row mt-2">

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {/* Left side: SVG + heading */}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <button
                            onClick={() => navigate(-1)}
                            style={{ background: "transparent", border: "none", cursor: "pointer", padding: 0 }}
                            title="Go back"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                fill="none"
                                stroke="#7F56DA"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <line x1="19" y1="12" x2="5" y2="12"></line>
                                <polyline points="12 19 5 12 12 5"></polyline>
                            </svg>
                        </button>
                        <h2 className='main-heading' style={{ margin: 0, color: "#7F56DA" }}>Add Holiday</h2>
                    </div>

                    {/* Right side: Academic Year */}
                    <div>
                        <label className="form-labell">Admission Academic Year</label>
                        <Select
                            options={sessions}
                            value={selectedSession}
                            onChange={opt => setSelectedSession(opt)}
                            styles={reactSelectStyles}
                            placeholder="Select Session"
                            // isClearable
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        // isDisabled={true}
                        />

                    </div>
                </div>

                <div className='col-md-12'>
                    <div className="row mt-3 d-flex justify-content-start">


                        <div className="col-md-4">
                            <label className="form-labell">Course</label>
                            <Select
                                value={selectedCourse}
                                onChange={(opt) => setSelectedCourse(opt)}
                                options={courseOptions}
                                styles={reactSelectStyles}
                                placeholder="Select Course"
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                isLoading={!courseOptions.length}
                            />
                        </div>

                        <div className="col-md-4">
                            <label className="form-labell">Semester</label>
                            <Select
                                value={selectedSemester || null}        // single value instead of array
                                onChange={(option) => setSelectedSemester(option || null)} // store single object
                                options={semesterOptions}
                                styles={reactSelectStyles}
                                placeholder="Select Semester"
                                isMulti={false}                        // disable multi-select
                                isDisabled={!semesterOptions.length}
                                menuPortalTarget={document.body}   // 🔹 Render menu at body level
                                menuPosition="fixed"
                            />

                        </div>

                        <div className="col-md-4">
                            <label className="form-labell">Section</label>
                            <Select
                                value={selectedSections}
                                onChange={(opts) => setSelectedSections(opts || [])}
                                options={sectionOptions}
                                styles={reactSelectStyles}
                                placeholder="Select Section(s)"
                                isMulti
                                isDisabled={!sectionOptions.length}
                                menuPortalTarget={document.body}   // 🔹 Render menu at body level
                                menuPosition="fixed"
                            />

                        </div>
                    </div>

                    <div className='sections mt-3'>
                        {!selectedCourse ? (
                            // CASE 1: No course selected
                            <div
                                className="col-12 d-flex flex-column align-items-center justify-content-center mt-5"
                                style={{ minHeight: 420, textAlign: 'center', color: '#6c757d' }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="80"
                                    height="80"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#6c757d"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M21 21l-4.35-4.35"></path>
                                    <circle cx="10" cy="10" r="7"></circle>
                                    <line x1="14" y1="10" x2="14" y2="10"></line>
                                </svg>
                                <p className="mt-3" style={{ fontSize: '18px', fontWeight: 500 }}>
                                    No records found
                                </p>
                                <p className="text-muted" style={{ fontSize: '14px' }}>
                                    Please select a course to view students.
                                </p>
                            </div>
                        ) : (
                            // CASE 2: Course selected → show table
                            <div className="row mt-2 d-flex justify-content-start">
                                <div className="col-md-6 d-flex align-items-center gap-2 mt-3 mb-3">
                                    <div className="form-check form-switch custom-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            style={{ cursor: 'pointer', zIndex: 1 }}
                                            checked={showStudents} // controlled by state
                                            onChange={() => {
                                                setShowStudents(prev => !prev)
                                                setShowEmployee(false)
                                            }} // toggle
                                            title="Enabel for student wise created fee plan"
                                        />
                                        <label className="form-check-label">
                                            {showStudents ? "Hide student list" : "Show student List"}
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-6 d-flex align-items-center gap-2 mt-3 mb-3">
                                    <div className="form-check form-switch custom-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            style={{ cursor: 'pointer', zIndex: 1 }}
                                            checked={showEmployee} // controlled by state
                                            onChange={() => {
                                                setShowEmployee(prev => !prev)
                                                setShowStudents(false)
                                            }} // toggle
                                            title="Enabel"
                                        />
                                        <label className="form-check-label">
                                            {showEmployee ? "Hide Employee list" : "Show Employee List"}
                                        </label>
                                    </div>
                                </div>


                                {showStudents && (
                                    <div className="col-md-12">
                                        <div className="row mt-4 align-items-center">
                                            <div className="col-md-6 d-flex align-items-center">
                                                <h5 className="mb-0">Select Students</h5>
                                            </div>
                                            <div className="col-md-6 d-flex align-items-center justify-content-end">
                                                <span className="text-muted small">
                                                    {selectedStudent?.length} / {students?.length} selected
                                                </span>
                                            </div>
                                        </div>

                                        <div className="feePlanTableContainer mt-1" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            <table className="table table-bordered mt-2 feeplantables">
                                                <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                                                    <tr>
                                                        <th>
                                                            <input
                                                                type="checkbox"
                                                                onChange={(e) => {
                                                                    if (e.target.checked) setSelectedStudent(students.map(s => s.id));
                                                                    else setSelectedStudent([]);
                                                                }}
                                                                checked={students.length > 0 && selectedStudent.length === students.length}
                                                            />


                                                        </th>
                                                        <th style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                                                            Student Name (Registration No.)
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Search students by name,registraion number,mobile number.."
                                                                value={searchTerm}
                                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                                style={{ maxWidth: '480px', height: '30px', fontSize: '14px' }}
                                                            />
                                                        </th>
                                                        <th>Course</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredStudents.length > 0 ? (
                                                        filteredStudents.map(stu => (
                                                            <tr key={stu.id}>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        // checked={Array.isArray(selectedStudent) && selectedStudent.includes(stu.id)}
                                                                        onChange={(e) => {
                                                                        }}
                                                                        checked={students.length > 0 && selectedStudent.length === students.length}
                                                                    />
                                                                </td>
                                                                <td>{stu.name} ({stu.rollNumber})</td>
                                                                <td>{selectedCourse?.label || "—"}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="3" className="text-center text-muted">
                                                                No student details found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>


                                    </div>)}
                                {showEmployee && (
                                    <div className="col-md-12">
                                        <div className="row mt-4 align-items-center">
                                            <div className="col-md-6 d-flex align-items-center">
                                                <h5 className="mb-0">Select Employees</h5>
                                            </div>
                                            <div className="col-md-6 d-flex align-items-center justify-content-end">
                                                <span className="text-muted small">
                                                    {selectedStudent?.length} / {students?.length} selected
                                                </span>
                                            </div>
                                        </div>
                                        <div className="feePlanTableContainer mt-1" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            <table className="table table-bordered mt-2 feeplantables">
                                                <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                                                    <tr>
                                                        <th>
                                                            <input
                                                                type="checkbox"
                                                                onChange={(e) => {
                                                                }}
                                                                checked={students.length > 0 && selectedStudent.length === students.length}
                                                            />
                                                        </th>
                                                        <th>Employee (Code)</th>
                                                        <th>Department</th>
                                                        <th>Designation</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {employeeData.length > 0 ? (
                                                        employeeData.map(emp => (
                                                            <tr key={emp.id}>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={Array.isArray(selectedStudent) && selectedStudent.includes(emp.id)}
                                                                        onChange={() => {
                                                                            setSelectedStudent(prev =>
                                                                                Array.isArray(prev)
                                                                                    ? prev.includes(emp.id)
                                                                                        ? prev.filter(id => id !== emp.id)
                                                                                        : [...prev, emp.id]
                                                                                    : [emp.id]
                                                                            );
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {`${emp.salutation || ""} ${emp.first_name} ${emp.middle_name || ""} ${emp.last_name || ""}`}
                                                                    ({emp.unique_code})
                                                                </td>
                                                                <td>{emp.department?.name || "—"}</td>
                                                                <td>{emp.designation?.name || "—"}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center text-muted">
                                                                No employee details found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="row mt-2 d-flex justify-content-start">
                        <div className="col-md-12">
                            {selectedStudent?.length > 0 && (
                                <>

                                    <div className="row mt-1 align-items-center justify-content-center">
                                        <div className="col-12 text-start">
                                            <h5 className="mb-1">Holiday Details</h5>
                                        </div>
                                    </div>


                                    <div className="row mb-2 mt-1 align-items-center">
                                        {/* Holiday Type */}
                                        <div className="col-md-3">
                                            <label className="form-labell mb-2" htmlFor="holidayType">
                                                Holiday Type<span className="astrisk">*</span>
                                            </label>
                                            <Select
                                                inputId="holidayType"
                                                options={holidayTypeOptionsWithAdd}
                                                value={holidayType}
                                                onChange={(val) => {
                                                    if (val?.value === "__add__") setShowHolidayTypeAddModal(true);
                                                    else setHolidayType(val);
                                                }}
                                                placeholder="Select Holiday Type"
                                                styles={{
                                                    ...reactSelectStyles,
                                                    option: (base, state) => ({
                                                        ...reactSelectStyles.option?.(base, state),
                                                        ...(state.data?.value === "__add__" && {
                                                            color: "#7F56DA",
                                                            fontWeight: "bold",
                                                            borderTop: "1px solid #ccc",
                                                            cursor: "pointer",
                                                            backgroundColor: state.isFocused ? "#f4eefe" : "white",
                                                        }),
                                                    }),
                                                    menuPortal: (base) => ({ ...base, zIndex: 99 }),
                                                }}
                                                isClearable
                                                menuPlacement="auto"
                                                noOptionsMessage={() => "+ Add Holiday Type"}
                                                aria-label="Holiday Type"
                                            />
                                            {/* <small className="text-muted">
                                                Select the category or type of holiday (e.g., National, Religious, Company-specific).
                                            </small> */}
                                        </div>

                                        {/* Holiday Name */}
                                        <div className="col-md-3">
                                            <label className="form-labell mb-2" htmlFor="holidayName">
                                                Holiday Name<span className="astrisk">*</span>
                                            </label>
                                            <input
                                                id="holidayName"
                                                type="text"
                                                className="form-control"
                                                placeholder="Holiday Name"
                                                value={holidayName}
                                                onChange={(e) => setHolidayName(e.target.value)}
                                                style={{ height: "45px" }}
                                                aria-label="Holiday Name"
                                            />
                                            {/* <small className="text-muted">
                                                Provide a clear and descriptive name for the holiday.
                                            </small> */}
                                        </div>

                                        {/* From Date */}
                                        <div className="col-md-3">
                                            <label className="form-labell mb-2" htmlFor="holidayFrom">
                                                From Date<span className="astrisk">*</span>
                                            </label>
                                            <input
                                                id="holidayFrom"
                                                type="date"
                                                className="form-control"
                                                value={holidayFrom}
                                                min={new Date().toISOString().split("T")[0]}
                                                onChange={(e) => {
                                                    setHolidayFrom(e.target.value);
                                                    if (holidayTo && e.target.value > holidayTo) setHolidayTo("");
                                                }}
                                                style={{ height: "45px" }}
                                                aria-label="Holiday Start Date"
                                            />
                                            {/* <small className="text-muted">
                                                Select the start date for the holiday. Cannot be earlier than today.
                                            </small> */}
                                        </div>

                                        {/* To Date */}
                                        <div className="col-md-3">
                                            <label className="form-labell mb-2" htmlFor="holidayTo">
                                                To Date<span className="astrisk">*</span>
                                            </label>
                                            <input
                                                id="holidayTo"
                                                type="date"
                                                className="form-control"
                                                value={holidayTo}
                                                min={holidayFrom || new Date().toISOString().split("T")[0]}
                                                onChange={(e) => setHolidayTo(e.target.value)}
                                                style={{ height: "45px" }}
                                                disabled={!holidayFrom}
                                                aria-label="Holiday End Date"
                                            />
                                            {/* <small className="text-muted">
                                                Select the end date for the holiday. Cannot be earlier than the start date.
                                            </small> */}
                                        </div>
                                    </div>

                                    {/* Recurrence Section */}
                                    <div className="row mb-2 mt-3">
                                        {/* Recurrence Type */}
                                        <div className="col-md-3">
                                            <label className="form-labell mb-2" htmlFor="recurrenceType">
                                                Recurrence Type
                                            </label>
                                            <Select
                                                inputId="recurrenceType"
                                                options={[
                                                    { label: "None", value: "none" },
                                                    { label: "Daily", value: "daily" },
                                                    { label: "Weekly", value: "weekly" },
                                                    { label: "Monthly", value: "monthly" },
                                                    { label: "Yearly", value: "yearly" },
                                                ]}
                                                value={recurrenceType}
                                                onChange={(val) => setRecurrenceType(val)}
                                                placeholder="Select Recurrence"
                                                styles={reactSelectStyles}
                                                aria-label="Recurrence Type"
                                            />
                                            <small className="text-muted">
                                                Choose how often this holiday should repeat. "None" means a single occurrence.
                                            </small>
                                        </div>

                                        {/* Repeat Interval */}
                                        {recurrenceType?.value !== "none" && (
                                            <div className="col-md-3">
                                                <label className="form-labell mb-2" htmlFor="repeatInterval">
                                                    Repeat Every
                                                </label>
                                                <input
                                                    id="repeatInterval"
                                                    type="number"
                                                    min={1}
                                                    className="form-control"
                                                    value={repeatInterval}
                                                    onChange={(e) => setRepeatInterval(e.target.value)}
                                                    style={{ height: "45px" }}
                                                    aria-label="Repeat Interval"
                                                />
                                                <small className="text-muted">
                                                    Specify how many {recurrenceType?.label?.toLowerCase()}s between each occurrence.
                                                </small>
                                            </div>
                                        )}

                                        {/* Days of Week (for weekly recurrence) */}
                                        {recurrenceType?.value === "weekly" && (
                                            <div className="col-md-3">
                                                <label className="form-labell mb-2" htmlFor="daysOfWeek">
                                                    Days of Week
                                                </label>
                                                <Select
                                                    inputId="daysOfWeek"
                                                    isMulti
                                                    options={[
                                                        { label: "Sunday", value: "sunday" },
                                                        { label: "Monday", value: "monday" },
                                                        { label: "Tuesday", value: "tuesday" },
                                                        { label: "Wednesday", value: "wednesday" },
                                                        { label: "Thursday", value: "thursday" },
                                                        { label: "Friday", value: "friday" },
                                                        { label: "Saturday", value: "saturday" },
                                                    ]}
                                                    value={daysOfWeek}
                                                    onChange={setDaysOfWeek}
                                                    styles={reactSelectStyles}
                                                    aria-label="Days of Week"
                                                />
                                                <small className="text-muted">
                                                    Select the days when this holiday should reoccur weekly.
                                                </small>
                                            </div>
                                        )}

                                        {/* Monthly Options */}
                                        {recurrenceType?.value === "monthly" && (
                                            <>
                                                <div className="col-md-3">
                                                    <label className="form-labell mb-2">Monthly Option</label>
                                                    <Select
                                                        options={[
                                                            { label: "Same day each month", value: "day_of_month" },
                                                            { label: "Specific weekday of month", value: "weekday_of_month" },
                                                        ]}
                                                        value={monthlyOption}
                                                        onChange={setMonthlyOption}
                                                        styles={reactSelectStyles}
                                                    />
                                                </div>

                                                {/* Specific Weekday of Month Fields */}
                                                {monthlyOption?.value === "weekday_of_month" && (
                                                    <>
                                                        <div className="col-md-3">
                                                            <label className="form-labell mb-2">Week of Month</label>
                                                            <Select
                                                                options={[
                                                                    { label: "First", value: "first" },
                                                                    { label: "Second", value: "second" },
                                                                    { label: "Third", value: "third" },
                                                                    { label: "Fourth", value: "fourth" },
                                                                    { label: "Last", value: "last" },
                                                                ]}
                                                                value={monthWeek}
                                                                onChange={setMonthWeek}
                                                                styles={reactSelectStyles}
                                                            />
                                                        </div>

                                                        <div className="col-md-3">
                                                            <label className="form-labell mb-2">Day of Week</label>
                                                            <Select
                                                                options={[
                                                                    { label: "Sunday", value: "sunday" },
                                                                    { label: "Monday", value: "monday" },
                                                                    { label: "Tuesday", value: "tuesday" },
                                                                    { label: "Wednesday", value: "wednesday" },
                                                                    { label: "Thursday", value: "thursday" },
                                                                    { label: "Friday", value: "friday" },
                                                                    { label: "Saturday", value: "saturday" },
                                                                ]}
                                                                value={monthWeekDay}
                                                                onChange={setMonthWeekDay}
                                                                styles={reactSelectStyles}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}

                                        {/* Repeat Until Date */}
                                        {recurrenceType?.value !== "none" && (
                                            <div className="col-md-3">
                                                <label className="form-labell mb-2" htmlFor="repeatUntil">
                                                    Repeat Until
                                                </label>
                                                <input
                                                    id="repeatUntil"
                                                    type="date"
                                                    className="form-control"
                                                    value={repeatUntil}
                                                    min={holidayFrom}
                                                    onChange={(e) => setRepeatUntil(e.target.value)}
                                                    style={{ height: "45px" }}
                                                    aria-label="Repeat Until Date"
                                                />
                                                <small className="text-muted">
                                                    Choose the last date for recurrence. Must be after the holiday start date.
                                                </small>
                                            </div>
                                        )}
                                    </div>


                                    <div className="row mb-2 mt-3 align-items-center">
                                        <div className='row'>
                                            <div className='col-md-3'>
                                                <label className="form-labell mb-2">
                                                    Authorised Person<span className="astrisk">*</span>
                                                </label>
                                                <Select
                                                    classNamePrefix="select"
                                                    isSearchable
                                                    isMulti   // <-- enable multi-select
                                                    name="employee"
                                                    options={helpdeskperson?.map(emp => ({
                                                        value: emp.id,
                                                        label: emp.name,
                                                    }))}
                                                    placeholder="-- Select Employee --"
                                                    value={helpdeskperson
                                                        ?.map(emp => ({
                                                            value: emp.id,
                                                            label: emp.name,
                                                        }))
                                                        .filter(option => selectedEmployeeIds?.includes(option.value))}  // <-- filter selected
                                                    onChange={(selected) => setSelectedEmployeeIds(selected?.map(s => s.value) || [])} // store array of ids
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        ...reactSelectStyles,
                                                        menuPortal: (base) => ({ ...base, zIndex: 9 }), // 👈 this will override
                                                    }}

                                                    menuPlacement="auto"
                                                // menuPosition="absolute"
                                                />

                                            </div>

                                        </div>
                                        <div className="row d-flex justify-content-end">
                                            <div className="col-md-6 d-flex justify-content-end gap-3">
                                                {/* <button
                                                    onClick={handleCancel}
                                                    style={{
                                                        backgroundColor: '#f44336',
                                                        color: '#fff',
                                                        border: 'none',
                                                        padding: '4px 20px',   
                                                        lineHeight: '20px',    // control button text height
                                                        borderRadius: '6px',
                                                        fontWeight: '500',
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.3s ease'
                                                    }}
                                                >
                                                    Cancel
                                                </button> */}

                                                <button className="add-btn"
                                                    // onClick={handleBeforeSubmit}
                                                    onClick={() => navigate(-1)}
                                                    disabled={!isFormValid}   // ✅ disable when not valid
                                                    style={{
                                                        opacity: !isFormValid ? 0.6 : 1,
                                                        cursor: !isFormValid ? "not-allowed" : "pointer",
                                                        background: !isFormValid ? '#d3d3d3' : '#7F56DA'
                                                    }}>
                                                    Create Holiday
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>



            <AddFeeHeadModal
                title="Add Holiday Type"
                btnTitle="Add Type"
                placeholder="Enter holiday type"
                isOpen={showHolidayTypeAddModal}
                onClose={() => setShowHolidayTypeAddModal(false)}
                onSubmit={handleAddHolidayType}
                setNewFeeHead={setNewHolidayType}
                newFeeHead={newHolidayType}
            />
            <ConfirmationModal
                isOpen={confirmationModalOpen}
                title="Confirm Submission"
                message="Are you sure you want to impose this fee?"
                onConfirm={handleConfirmFeePlan}
                isSubmitting={isSubmitting}
                onCancel={handleCancelFeePlan}
                showCheckbox={false}
            />

            <OtpModal
                title="Confirmation!"
                heading="Please enter 6 digit OTP to confirm the fee imposition"
                isOpen={otpModal}
                onConfirm={handleOtpConfirm}
                onCancel={handleOtpCancel}
                onResend={handleOtpResend}
                studentResponse={specializationSubmitResponse}
            />

            <ImposeFeePlanPreview
                isOpen={previewOpen}
                onClose={() => setPreviewOpen(false)}
                planMode={previewData?.planMode}
                payload={previewData?.payload}
                selectedCourse={selectedCourse}
                selectedSemester={selectedSemester}
                students={students}
                selectedStudent={selectedStudent}
                selectedSessionName={selectedSession?.label || ""}
                feeRows={feeRows}
                onContinue={() => {
                    setPreviewOpen(false);
                    setConfirmationModalOpen(true);
                }}
            />



        </>
    )
}




export default AddHolidays